import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AUTH_URL } from "../../config/env";

// redirect to auth service for password reset
const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const resetCode = searchParams.get("resetCode");

  useEffect(() => {
    // redirect to auth service reset password page with the token
    const authResetUrl = `${AUTH_URL}/reset-password${resetCode ? `?token=${resetCode}` : ""}`;
    window.location.href = authResetUrl;
  }, [resetCode]);

  // show loading while redirecting
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#a2f4fd",
      }}
    >
      <p>Redirecting to password reset...</p>
    </div>
  );
};

export default ResetPasswordPage;
